import {PermissionRuleMap} from '@xin/xin-core';

export const PermissionRule: PermissionRuleMap = {
  //首页员工概况+备忘
  'employee-stat': '020802',
  //首页招聘备忘
  'schedule-recruitment': '07',
  // 人事月表
  'employee_default': '0201',
  // 添加员工（添加待入职，添加在职）
  'employee_info': '02040201||02040211',
  //导入员工（导入在职，导入待入职，导入离职）
  'employee_import':'02040502||02040501||02040503',
  //导入员工信息
  'employee_import_info':'02040505||02040506||02040507||02040508||02040509',
  // 查看报表
  'employee_view_report': '02010101',
  // 工资归档博爱表
  'payroll_archive_report': '030304',
  // 工资设置
  'payroll_salary_setting': '030704',
  // 社保报表
  'insurance_default': '040201',
  // 社保归档报表
  'insurance_archive_report': '040202',
  // 考勤设置
  'attendance_setting': '0504',
  //查看打卡方案列表
  'attendance_view_daka_plan':'05040107',
  // 考勤加班设置列表
  'check_overtime_settings_list': '05040504',
  //考勤-月度报表下全部勾选
  'attendance_month_report':'05030901||05030911||05030912||05030913||05030903||05030909||05030910',
  // 考勤归档报表
  'attendance_archive_report': '05030903',
  'checkSalaryGroup':'03071101', // 查看工资组
  // 考勤权限
  'attendance':'05',
  // 招聘权限
  'recruitment':'07',
  'r-statistics': '0704', //招聘统计
  'r-setting-template': '070502', //招聘设置-模板管理
  'r-edit-referral-rule': '070508', //内推奖励规则
  'r-resume-monitor': '0717', //招聘统计

  // okr权限
  'appraisalOkr':'1306',
  //  数据平台
  'platform': '1801',
  // 薪豆权限
  'tab_xindou': '010601',
  //奖金包权限
  'payroll_bonus_package': '0308',
  //内推奖励列表权限
  'r-reward-list':'070601',
  // 绩效kpi权限
  'performanceAppraisal':'1301',
  //工资成本拆分tab
  'costSplit' : '030707',
  // 人才模块
  'talents-index': '2001',
  // 人才档案
  'talents-archives': '2004',
  // 人才评估
  'talents-evaluation': '2005',
  //加班设置
  'overtime_settings':"050405",
  //编外人员
  'side-personnel' : '0310',
  //档案
  'portrait':'10',
  //品牌设置
  'tab_brand': '0103',

  // 劳动合同管理
  labor_contract_management: '02040206',
  // 编辑员工信息
  edit_employee_information: '02040103',
};
